import { calcResize } from 'components/Layout/styles';
import styled from 'styled-components';
import { mediaBreakpointUp } from 'utils/styledCssHelpers';

export const SPageSlug = styled.p`
  color: #707070;
  margin-top: 1rem;
  margin-bottom: 2rem;
  font-weight: 300;
  font-size: ${calcResize(15, 18)};
`;

export const SContainer = styled.div`
  padding: 1rem 0.2rem;

  ${mediaBreakpointUp(
    'md',
    `
    padding: 4rem;
    padding-bottom: 10rem;
  `,
  )}
`;

export const SPageContainer = styled.section`
  // border: 1px solid #707070;
  border-radius: 10px;
  background: #fff;
  padding: 2rem 1rem;

  box-shadow: 3px 3px 1em #e7e7e7, 3px 3px 1em #e7e7e7;

  margin-top: 3rem;

  ${mediaBreakpointUp(
    'md',
    `
  padding: 3rem 5rem;
  margin-top: 4rem;


  `,
  )}

  a, a:hover {
    text-decoration: none;
  }
`;

export const SPageTitleLink = styled.h4`
  color: #707070;
  font-size: ${calcResize(20, 25)};
  line-height: 1;
  margin-top: 3rem;
`;

export const Stitle = styled.h2`
  color: #707070;
  text-decoration: none;
  font-weight: 400;
  margin-bottom: 1rem;
  font-size: ${calcResize(35, 40)};
`;

export const SH1 = styled.h1`
  margin-top: 20px;
  font-size: ${calcResize(40, 45)};
`;
